import React, { useState } from 'react';
import './App.css';
import Header from './component/Header';
import Hero from './component/Hero';
import Brands from './component/Brands';
import BrandDetails from './component/BrandDetails';
import Contact from './component/Contact';
import Footer from './component/Footer';

function App() {
  const [selectedBrand, setSelectedBrand] = useState(null);

  return (
    <div className="App">
      <Header />
      <Hero />
      <Brands onBrandClick={setSelectedBrand} />
      <BrandDetails 
        selectedBrand={selectedBrand} 
        onClose={() => setSelectedBrand(null)} 
      />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;